import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { safeRest, uniqueId } from '@wds/utils';
import { INPUT_COLORS } from '@wds/helpers';
import { useTheme } from 'react-jss';
import { Label } from '@wds/internal-components';

import useStyles from './useStyles';

const InputGroup = ({
  children,
  id,
  label,
  stretched,
  disabled,
  color,
  ...rest
}) => {
  const theme = useTheme();
  const inputID = useMemo(() => id || uniqueId('input'), [id]);
  const { wrenchInputGroup } = useStyles({ color, stretched, disabled, theme });

  return (
    <>
      <If condition={label}>
        <Label htmlFor={inputID}>{label}</Label>
      </If>
      <div className={wrenchInputGroup} {...safeRest(rest)}>
        {children}
      </div>
    </>
  );
};

InputGroup.propTypes = {
  /**
   * Composed of Input and InputGroupAddon components
   */
  children: PropTypes.node.isRequired,
  /**
   * Unique identifier for InputGroup
   */
  id: PropTypes.string,
  /**
   * Add label for input group
   */
  label: PropTypes.node,
  /**
   * Extends input group to fit the full width of parent container
   */
  stretched: PropTypes.bool,
  /**
   * If true, will disable the input group
   */
  disabled: PropTypes.bool,
  /**
   * Color variants for Input Group
   */
  color: PropTypes.oneOf(INPUT_COLORS),
};

InputGroup.defaultProps = {
  id: undefined,
  label: undefined,
  stretched: false,
  disabled: false,
  color: undefined,
};

export default InputGroup;
